



























































































































































































































































































































































































































import {Component, Vue} from "vue-property-decorator";
import upload from "@/components/upload/src/index.vue";
import {genSpu, saveSpu, getSkuFillList, genSpuSimilar, genSkuList, getConfig, genSpuByUrl} from '@/services/api'
import {isObjectValueEqualNew} from '@/services/common'
import draggable from 'vuedraggable'
import {SpuManage, TSku} from '@/model/Spu.ts'
import {
    BaseAndSupplierSpec, BaseAndSupplierSpecValue,
    SpecManage,
    SpecSelect,
    SpecTable,
    SupplierSpecSelect,
    SupplierSpecTable
} from "@/model/Spec";
import {GoodSpec} from "@/model/Item";
import {SpecValue, TSpec} from "@/model/Spu";

@Component({
  components: {
    'zf-upload': upload,
    draggable
  },
})
export default class SpuModify extends Vue {
  public JSON = JSON;
  // 页面类型: ADD: 新建; MODIFY: 修改; PARSEMODIFY: 解析修改(新建解析成功后editable为false，权限同MODIFY)
  public ADD = 'add';
  public MODIFY = 'modify';
  public PARSEMODIFY = 'parse_modify';
  // 解析状态
  public parsed = false;

  // 当前tab
  public activeName: 'spuInfo'|'skuList' = 'spuInfo';

  // 解析url
  public supperlierUrl = '';
  // 表单信息
  public formData: SpuManage = {
    'supperlierUrl': '',
    'orderRemark1688': '',
    "covers": [],
    "specList": [],
    "skuList": [],
    "spuAttrList": [],
    "similarList": [] // 弃用
  };
 public originFormData!: SpuManage;
  //spu属性配置列表
  public spuAttrAllList: string[] = [];
  // 相似spu列表
  public similarList: number[] = [];
  // 已查询相似列表  -1未检测 0检测中 1检测完成 10无需检测
  public similarChecked = 10;

  // 解析sku
  public fillSkuVisible = false;
  public fillSkuList: TSku[] = [];
  public activeFillSku: TSku = {};
  public activeSkuIndex = -1;

  // 批量填写sku
  public editSkuVisible = false;
  public skuSelectedList: TSku[] = [];
  public editingSku: TSku = {};

  // 批量修改sku供应商
  public editSkuSupplierVisible = false;

  public checkSkuErrorList: number[] = [];
  public checkSkuInfoErrorMessages: string[] = [];
  // 批量解析检测：与最新1688规格不一致的sku行索引(标红)
  public skuDiffRows: number[] = [];
  // 批量解析缓存：采购链接 → 最新解析出的SKU列表
  public latestSkuMap: Map<string, any[]> = new Map();

  // 检验sku信息
  public checkSkuInfoVisible = false;
  // spec表格数据
  public specTableData: SupplierSpecTable[] = [];
  // spec表格合并
  public specSpanCtrl: number[] = [];
  // spec下拉列表
  public specSelect: SupplierSpecSelect = {};
  // spec对齐信息
  private specData: BaseAndSupplierSpec[] = [];
  // 新的供应商url
  public newSupplierUrl = '';
  // 新供应商spu信息
    public newSupplierData: SpuManage = {
        'supperlierUrl': '',
        'orderRemark1688': '',
        "covers": [],
        "specList": [],
        "skuList": [],
        "spuAttrList": [],
        "similarList": [] // 弃用
    };

  // 上传图片地址
  public uploadUrl = (process.env.VUE_APP_BASE_API.length == 0 ? (location.origin + "/") : process.env.VUE_APP_BASE_API) + 'api/util/uploadImages';
  // spu图回显列表
  public coverShowList: {url: string, name: string}[] = [];
  // spu图上传列表
  public coverList: {url: string, name: string}[] = [];
  // 大图展示控制
  public dialogVisible = false;
  // 大图展示路径
  public dialogImageUrl = '';
  // 套装规格新增弹窗
  public bundleDialogVisible = false;
  public bundleSpec: TSpec | null = null;
  public bundleForm: SpecValue = {
    name: '',
    resource: '',
    isHidden: false,
    oldHidden: false,
    bundleSpecValueNames: [],
    bundleSpecValueCountMap: {}
  };
  // 检查有无修改
  public checkTimer!: number;
  public modified = false;

  /**
   * 初始化方法
   */
  async created(): Promise<void> {
    this.initForm();
    this.getConfig();
    if (this.scene === this.MODIFY) {
      const id = parseInt(this.$route.params.id);
      await this.getSpuDetailById({spuId: id});
    }
    this.checkTimer = setInterval(() => {
      this.formData.covers = this.coverList.map(item => item.url);
      this.modified = !isObjectValueEqualNew(this.formData, this.originFormData);
    }, 1000);
  }

  beforeDestroy() {
    clearInterval(this.checkTimer);
  }

  /**
   * watch
   * 当前的页面情景
   **/
  get scene(): string|undefined {
    // 解析后不可编辑的场景为PARSE，权限等同于MODIFY
    if(this.parsed && !this.formData.editable) {
      return this.PARSEMODIFY;
    }
    if(/^\/spu\/add/.test(this.$route.path)) {
      return this.ADD;
    }
    if(/^\/spu\/modify\//.test(this.$route.path)) {
      return this.MODIFY;
    }
  }

  /**
   * tab改变钩子
   **/
  changeTab(tab: {name: 'spuInfo'|'skuList'}) {
    console.log(tab.name)
    if (tab.name === 'skuList') {
      genSkuList(this.buildSubmitSpu(this.formData), true).then(res => {
        if (res.data && res.data.code === 200) {
          this.formData.skuList = res.data.data.skuList;
        } else {
          this.$message.error(res.data.message);
        }
      }).catch(() => {})
    }
  }

    /**
     * 获取字典信息
     */
    async getConfig(): Promise<void> {
        if (this.spuAttrAllList === [] || this.spuAttrAllList.length === 0) {
            await getConfig({type: 'spu_attr'}).then(res => {
                if (res.data && res.data.code === 200) {
                    this.spuAttrAllList = res.data.data || [];
                }else {
                    this.$message.error(res.data.message);
                }
            }).catch(() => {})
        }
    }

  /**
   * 通过id获取spu详情
   * @param params
   */
  async getSpuDetailById(params: {spuId: number}): Promise<void> {
    await genSpu(params, true).then(res => {
      if (res.data && res.data.code === 200) {
        this.formData = res.data.data;
        this.initForm();
      } else {
        this.$message.error(res.data.message);
      }
    }).catch(() => {})
  }

  /**
   * 通过url获取spu详情
   * @param params
   */
  async getSpuDetailByUrl(params: {spuId?: number, supperlierUrl: string}): Promise<void> {
    await genSpu(params, true).then(res => {
      if (res.data && res.data.code === 200) {
        this.formData = res.data.data;
        this.parsed = true;
        this.initForm();
      } else {
        this.$message.error(res.data.message);
      }
    }).catch(() => {})
    if (this.scene === this.ADD) {
      await this.genSpuSimilar();
    }
  }

  /**
   * 通过covers查询相似spuId
   */
  async genSpuSimilar() {
    this.similarChecked = 0;
    this.formData.covers = this.coverList.map(item => item.url);
    await genSpuSimilar(this.formData.covers || [], false).then(res => {
      if (res.data && res.data.code === 200) {
        this.similarList = res.data.data;
      } else {
        this.$message.error(res.data.message);
      }
    }).catch(() => {});
    this.similarChecked = 1;
  }

  /**
   * 清空spu信息
   */
  clearSpuDetail() {
    this.formData = {};
    this.initForm();
    this.parsed = false;
    this.similarChecked = 10;
  }

  /**
   * item数据初始化
   */
  initForm(): void {
    this.normalizeBundleSpecValues(this.formData);
    this.formData.covers = this.formData.covers || [];
    this.formData.specList = this.formData.specList || [];
    this.formData.skuList = this.formData.skuList || [];
    this.formData.similarList = this.formData.similarList || [];
    this.formData.orderRemark1688 = this.formData.orderRemark1688 || '';
    this.supperlierUrl = this.formData.supperlierUrl || '';
    this.coverList = this.formData.covers.map((url: string) => ({
      name: '',
      url
    }))
    this.coverShowList = [...this.coverList];
    this.originFormData = JSON.parse(JSON.stringify(this.formData));
    this.modified = false;
  }

  normalizeBundleSpecValues(spu: SpuManage): void {
    (spu.specList || []).forEach(spec => {
      (spec.specValue || []).forEach(value => {
        if ((!value.bundleSpecValueNames || value.bundleSpecValueNames.length === 0)
            && value.bundleSpecValueCounts && value.bundleSpecValueCounts.length > 0) {
          value.bundleSpecValueNames = value.bundleSpecValueCounts.map(item => item.name || '').filter(name => !!name);
        }
      });
    });
  }

  buildSubmitSpu(spu: SpuManage): SpuManage {
    const submitSpu = JSON.parse(JSON.stringify(spu));
    (submitSpu.specList || []).forEach((spec: TSpec) => {
      (spec.specValue || []).forEach((value: SpecValue) => {
        delete value.isNew;
      });
    });
    return submitSpu;
  }

  mergeBundleSpecValues(savedSpu: SpuManage, submittedSpu: SpuManage): SpuManage {
    const result = JSON.parse(JSON.stringify(savedSpu));
    (submittedSpu.specList || []).forEach((submittedSpec, specIndex) => {
      const resultSpec = (result.specList || []).find((spec: TSpec) => spec.specName === submittedSpec.specName)
          || (result.specList || [])[specIndex];
      if (!resultSpec) {
        return;
      }
      (submittedSpec.specValue || []).forEach(submittedValue => {
        if (!this.isBundleValue(submittedValue)) {
          return;
        }
        const resultValue = (resultSpec.specValue || []).find((value: SpecValue) => value.name === submittedValue.name);
        if (!resultValue) {
          return;
        }
        if (!resultValue.bundleSpecValueNames || resultValue.bundleSpecValueNames.length === 0) {
          resultValue.bundleSpecValueNames = submittedValue.bundleSpecValueNames;
        }
        if (!resultValue.bundleSpecValueCounts || resultValue.bundleSpecValueCounts.length === 0) {
          resultValue.bundleSpecValueCounts = submittedValue.bundleSpecValueCounts;
        }
      });
    });
    this.normalizeBundleSpecValues(result);
    return result;
  }

  checkSkuInfoDialogSuccess() :void {
      this.formData.covers = this.coverList.map(item => item.url);
      this.checkSkuInfoDialog();
    const savedFormData = JSON.parse(JSON.stringify(this.formData));
    saveSpu(this.buildSubmitSpu(this.formData), true).then(res => {
      if (res.data && res.data.code === 200 && res.data.data.spuId) {
        this.$message.success('保存成功');
        this.formData = this.mergeBundleSpecValues(res.data.data, savedFormData);
        this.originFormData = JSON.parse(JSON.stringify(this.formData));
        this.modified = false;
        this.$router.push(`/spu/modify/${res.data.data.spuId}`)
      } else {
        this.$message.error(res.data.message);
      }
    }).catch(() => {})
      
  }

  tableRowClassName({row,rowIndex}: {row :any, rowIndex :number}) :String {
  // 批量解析检测差异行优先标红
  if(this.skuDiffRows.indexOf(rowIndex) > -1){
      return 'row-diff';
  }
  if(this.checkSkuErrorList.indexOf(rowIndex) > -1){
      return 'success-row';
  }
  return '';
  }

  /**
   * 批量解析：按去重后的采购链接调 sku/list(refresh=true) 拉全最新SKU，结果缓存到 latestSkuMap
   */
  public async fetchLatestSkus(): Promise<void> {
      const list: any[] = this.formData.skuList || [];
      const urls: string[] = [...new Set(list.map((r: any) => r.supplierUrl).filter(Boolean))];
      this.latestSkuMap = new Map();
      for (const url of urls) {
          try {
              const res: any = await getSkuFillList({ supperlierUrl: url, refresh: true });
              this.latestSkuMap.set(url, (res.data && res.data.data) || []);
          } catch (e) {
              this.latestSkuMap.set(url, []);
          }
      }
  }

  /**
   * 批量解析检测：当前表格里 aliSkuId 不在最新解析结果中的行标红（规格已变化/失效）
   */
  public async batchCheckSkuDiff() {
      const list: any[] = this.formData.skuList || [];
      const urls: string[] = [...new Set(list.map((r: any) => r.supplierUrl).filter(Boolean))];
      if (urls.length === 0) {
          this.$message.warning('没有可解析的采购链接');
          return;
      }
      this.skuDiffRows = [];
      this.$message.info(`开始解析 ${urls.length} 个商品链接...`);
      await this.fetchLatestSkus();
      const latestIds: string[] = [];
      this.latestSkuMap.forEach((skus: any[]) => {
          skus.forEach((s: any) => { if (s.aliSkuId) latestIds.push(String(s.aliSkuId)); });
      });
      let ok = 0;
      list.forEach((row: any, i: number) => {
          if (!row.supplierUrl) { return; }
          if (!row.aliSkuId || latestIds.indexOf(String(row.aliSkuId)) < 0) {
              this.skuDiffRows.push(i);
          } else {
              ok++;
          }
      });
      const diff = this.skuDiffRows.length;
      if (diff > 0) {
          this.$message.warning(`检测完成：${diff} 行与最新规格不一致（已标红），${ok} 行一致`);
      } else {
          this.$message.success(`检测完成：${ok} 行全部与最新规格一致`);
      }
  }

  /**
   * 替换全部：把标红的不一致SKU行，按规格文本(skuText)匹配到最新解析结果并替换数据，
   * 匹配不上的保持标红提示手动处理
   */
  public async replaceAllDiffSku() {
      const list: any[] = this.formData.skuList || [];
      const urls: string[] = [...new Set(list.map((r: any) => r.supplierUrl).filter(Boolean))];
      if (urls.length === 0) {
          this.$message.warning('没有可解析的采购链接');
          return;
      }
      try {
          await this.$confirm('将重新解析并替换所有不一致SKU（按规格文本匹配最新1688数据），是否继续？', '替换全部', { type: 'warning' });
      } catch (e) {
          return; // 用户取消
      }
      this.$message.info(`开始解析并替换 ${urls.length} 个商品链接...`);
      await this.fetchLatestSkus();
      this.skuDiffRows = [];
      let replaced = 0, unmatched = 0;
      list.forEach((row: any, i: number) => {
          if (!row.supplierUrl) { return; }
          const parsed: any[] = this.latestSkuMap.get(row.supplierUrl) || [];
          const latestIds = parsed.map((s: any) => String(s.aliSkuId));
          if (row.aliSkuId && latestIds.indexOf(String(row.aliSkuId)) >= 0) {
              return; // 已是最新，跳过
          }
          // 不一致：按规格文本(skuText)匹配最新SKU
          const target = parsed.find((s: any) =>
              s.skuText && row.skuText && String(s.skuText).trim() === String(row.skuText).trim());
          if (target) {
              row.supplierProductId = target.supplierProductId;
              row.aliSkuId = target.aliSkuId;
              row.supplierSkuName = target.supplierSkuName;
              row.cost = target.cost;
              row.costDouble = target.costDouble;
              replaced++;
          } else {
              this.skuDiffRows.push(i); // 匹配不上，保持标红
              unmatched++;
          }
      });
      if (replaced > 0) {
          this.$message.success(`替换完成：${replaced} 行已替换为最新规格，${unmatched} 行未匹配（仍标红）`);
      } else {
          this.$message.warning(`未替换：${unmatched} 行无法按规格文本匹配到最新SKU（已标红，请手动处理）`);
      }
  }

  checkSkuInfo(): boolean {
      if(this.formData.skuList == null || this.formData.skuList.length == 0){
          return false;
      }
      this.checkSkuErrorList = [];
      this.checkSkuInfoErrorMessages = [];
      let flag = false;
      for (let i = 0 ; i < this.formData.skuList.length;i++){

          let sku = this.formData.skuList[i]
          if(sku ==  undefined){
           continue;
          }
          let weight = sku.weight || 0; 
          let height = sku.height || 0;
          let width  = sku.width || 0;
          let length = sku.length || 0;
          let costDouble = sku.costDouble || 0;
          let errFlag = false;
          let skuErrorMessages: string[] = [];
          console.log("当前第"+i+"个")
          if(weight < 0.1 || weight > 2){
              console.log("重量完善错误!"+weight)
              flag = true;
              errFlag = true;
              skuErrorMessages.push(`重量${weight}kg，不在0.1-2kg范围内`);
          }
          let skuV = length*height*width;
          if(skuV < 500 || skuV >30000){
              console.log("体积完善错误!" +skuV)
              flag = true;
              errFlag = true;
              skuErrorMessages.push(`体积${skuV}cm³，不在500-30000cm³范围内`);
          }
          if(costDouble < 5 || costDouble >100){
              console.log("采购价完善错误!"+costDouble)
              flag = true;
              errFlag = true;
              skuErrorMessages.push(`采购价${costDouble}，不在5-100范围内`);
          }
          if(sku.hscode && !/^\d{6,10}$/.test(String(sku.hscode))){
              flag = true;
              errFlag = true;
              skuErrorMessages.push(`HScode ${sku.hscode} 需为6-10位纯数字`);
          }
          if(sku.ean && !/^(?:\d{8}|\d{12,14})$/.test(String(sku.ean))){
              flag = true;
              errFlag = true;
              skuErrorMessages.push(`EAN ${sku.ean} 需为8位、或12-14位纯数字`);
          }

          if(errFlag){
              this.checkSkuErrorList.push(i);
              this.checkSkuInfoErrorMessages.push(`第${i + 1}个SKU：${skuErrorMessages.join('；')}`);
          }
      }
      if(flag){
          this.checkSkuInfoVisible = true;
          return false;
      }
      return true;

     
  }
  /**
   * 检验sku信息
   */
    checkSkuInfoDialog(){
        this.checkSkuInfoVisible = false;
        this.checkSkuErrorList = []
        this.checkSkuInfoErrorMessages = []
    }

  /**
   * 上传spu信息
   */
  submit(): void {
    if (!this.checkForm()) {
      return;
    }
    if(this.checkSkuInfo()){
      const savedFormData = JSON.parse(JSON.stringify(this.formData));
       saveSpu(this.buildSubmitSpu(this.formData), true).then(res => {
      if (res.data && res.data.code === 200 && res.data.data.spuId) {
        this.$message.success('保存成功');
        this.formData = this.mergeBundleSpecValues(res.data.data, savedFormData);
        this.$router.push(`/spu/modify/${res.data.data.spuId}`)
      } else {
        this.$message.error(res.data.message);
      }
    }).catch(() => {}) 
    }
  }
  /**
   * 校验表单内容是否通过
   */
  checkForm(): boolean {
    if (this.formData.supperlierUrl === ''){
      if (this.supperlierUrl === ''){
        const skuWithUrl = this.formData.skuList?.find(sku => sku?.supplierUrl);
        if (!skuWithUrl) {
          this.$message.error('采购链接不允许为空');
          return false;
        }
        this.formData.supperlierUrl = skuWithUrl.supplierUrl;
      } else {
        this.formData.supperlierUrl = this.supperlierUrl;
      }
    }
    if (this.formData.spuAttrList?.length === 0) {
      this.$message.error('请选择spu属性');
      return false;
    }
    if (!this.formData.name){
      this.$message.error('请输入spu名称');
      return false;
    }
    if (!this.formData.covers || this.formData.covers.length === 0){
      this.$message.error('请上传spu图片');
      return false;
    }
    return true;
  }

  /**
   * 添加规格
   * @param specs 规格列表
   */
  addSpec(specs: any[]): void  {
    specs.push({specValue: [{isNew: true}]});
    this.$forceUpdate();
  }

  /**
   * 删除规格
   * @param specs 规格列表
   * @param index 删除索引
   */
  deleteSpec(specs: any[], index: number): void  {
    specs.splice(index, 1);
  }

  /**
   * 添加规格小项
   * @param specValue 规格小项列表
   */
  addSpecValue(specValue: any[]): void  {
    specValue.push({isNew: true});
  }

  syncSpecValueBaseName(value: SpecValue, spec?: TSpec): void {
    if (spec && this.isSpecValueUsedByBundle(value, spec)) {
      value.name = value.baseName || value.name;
      this.$message.warning('已被套装选择的规格小项不能修改名称');
      return;
    }
    const oldBaseName = value.baseName;
    const newBaseName = value.name;
    if (value.isNew) {
      value.baseName = newBaseName;
      return;
    }
    if (oldBaseName && newBaseName && oldBaseName !== newBaseName && this.formData.skuList) {
      this.formData.skuList.forEach((sku: TSku) => {
        if (!sku.skuText) {
          return;
        }
        const skuTextValues = sku.skuText.split(',');
        if (skuTextValues.indexOf(oldBaseName) === -1) {
          return;
        }
        sku.skuText = skuTextValues.map(skuTextValue => skuTextValue === oldBaseName ? newBaseName : skuTextValue).join(',');
      });
    }
    value.baseName = newBaseName;
  }

  isSpecValueUsedByBundle(value: SpecValue, spec: TSpec): boolean {
    if (!value || this.isBundleValue(value) || !spec || !spec.specValue) {
      return false;
    }
    const valueName = value.baseName || value.name;
    if (!valueName) {
      return false;
    }
    return spec.specValue.some(specValue => {
      if (!this.isBundleValue(specValue)) {
        return false;
      }
      const bundleSpecValueNames = specValue.bundleSpecValueCounts && specValue.bundleSpecValueCounts.length > 0
          ? specValue.bundleSpecValueCounts.map(item => item.name)
          : specValue.bundleSpecValueNames;
      return (bundleSpecValueNames || []).indexOf(valueName) > -1;
    });
  }

  get bundleCandidates(): SpecValue[] {
    if (!this.bundleSpec || !this.bundleSpec.specValue) {
      return [];
    }
    return this.bundleSpec.specValue.filter(value => !!value.name && !value.isHidden && !this.isBundleValue(value));
  }

  isBundleValue(value: SpecValue): boolean {
    return !!(value.bundleSpecValueNames && value.bundleSpecValueNames.length > 0);
  }

  openBundleDialog(spec: TSpec): void {
    this.bundleSpec = spec;
    this.bundleForm = {
      name: '',
      resource: '',
      isHidden: false,
      oldHidden: false,
      bundleSpecValueNames: [],
      bundleSpecValueCountMap: this.createBundleCountMap(spec)
    };
    this.bundleDialogVisible = true;
  }

  resetBundleDialog(): void {
    this.bundleSpec = null;
    this.bundleForm = {
      name: '',
      resource: '',
      isHidden: false,
      oldHidden: false,
      bundleSpecValueNames: [],
      bundleSpecValueCountMap: {}
    };
  }

  handleBundleUploadSuccess(res: any): void {
    if (res && res['result'][0]) {
      this.bundleForm.resource = res['result'][0];
    }
  }

  createBundleCountMap(spec: TSpec | null): {[name: string]: number} {
    const countMap: {[name: string]: number} = {};
    (spec && spec.specValue ? spec.specValue : []).forEach(value => {
      if (value.name && !value.isHidden && !this.isBundleValue(value)) {
        countMap[value.name] = 1;
      }
    });
    return countMap;
  }

  syncBundleCountMap(): void {
    const countMap = this.bundleForm.bundleSpecValueCountMap || {};
    const nextCountMap: {[name: string]: number} = {};
    this.bundleCandidates.forEach(value => {
      if (value.name) {
        nextCountMap[value.name] = countMap[value.name] || 1;
      }
    });
    this.bundleForm.bundleSpecValueCountMap = nextCountMap;
  }

  formatBundleCount(name: string): void {
    if (!this.bundleForm.bundleSpecValueCountMap) {
      this.bundleForm.bundleSpecValueCountMap = {};
    }
    const value = this.bundleForm.bundleSpecValueCountMap[name];
    const count = parseInt(value + '');
    if (!value) {
      return;
    }
    this.bundleForm.bundleSpecValueCountMap[name] = count > 0 ? count : 1;
  }

  confirmBundleSpec(): void {
    const selectedNames = (this.bundleForm.bundleSpecValueNames || []).filter(name => !!name);
    this.syncBundleCountMap();
    const bundleSpecValueCounts = selectedNames.map(name => ({
      name,
      count: this.bundleForm.bundleSpecValueCountMap ? parseInt(this.bundleForm.bundleSpecValueCountMap[name] + '') : 1
    }));
    const name = (this.bundleForm.name || '').trim();
    if (selectedNames.length < 1) {
      this.$message.error('请至少选择1个规格小项');
      return;
    }
    if (bundleSpecValueCounts.some(item => !item.count || item.count < 1 || item.count % 1 !== 0)) {
      this.$message.error('规格小项数量必须为正整数');
      return;
    }
    const totalCount = bundleSpecValueCounts.reduce((sum, item) => sum + (item.count || 0), 0);
    if (selectedNames.length === 1 && totalCount <= 1) {
      this.$message.error('单品套装数量需大于1件，或至少选择2个规格小项');
      return;
    }
    if (!name) {
      this.$message.error('请输入套装名称');
      return;
    }
    if (!this.bundleSpec || !this.bundleSpec.specValue) {
      return;
    }
    const selectedKey = [...bundleSpecValueCounts].sort((a, b) => (a.name || '').localeCompare(b.name || '')).map(item => `${item.name}:${item.count}`).join(',');
    const duplicated = this.bundleSpec.specValue.some(value => {
      if (!this.isBundleValue(value)) {
        return false;
      }
      const valueCounts = value.bundleSpecValueCounts && value.bundleSpecValueCounts.length > 0
          ? value.bundleSpecValueCounts
          : (value.bundleSpecValueNames || []).map(valueName => ({name: valueName, count: 1}));
      return [...valueCounts].sort((a, b) => (a.name || '').localeCompare(b.name || '')).map(item => `${item.name}:${item.count || 1}`).join(',') === selectedKey;
    });
    if (duplicated) {
      this.$message.error('当前套装规格已存在');
      return;
    }
    this.bundleSpec.specValue.push({
      name,
      resource: this.bundleForm.resource,
      isHidden: false,
      oldHidden: false,
      bundleSpecValueNames: selectedNames,
      bundleSpecValueCounts
    });
    const hidden = selectedNames.some(selectedName => {
      const value = this.bundleSpec!.specValue!.find(item => item.name === selectedName);
      return !!(value && value.isHidden);
    });
    if (hidden) {
      this.$message.warning(`${name}包含已下架规格`);
    }
    this.bundleDialogVisible = false;
  }

  bundleContainsHiddenValue(value: SpecValue, spec: TSpec): boolean {
    if (!value.bundleSpecValueNames || !spec.specValue) {
      return false;
    }
    return value.bundleSpecValueNames.some(name => {
      const included = spec.specValue!.find(item => item.name === name && !this.isBundleValue(item));
      return !!(included && included.isHidden);
    });
  }

  /**
   * 删除规格小项
   * @param specValue 规格小项列表
   * @param index 删除索引
   */
  deleteSpecValue(specValue: any[], index: number): void  {
    specValue.splice(index, 1);
  }

  /**
   * 隐藏规格小项
   * @param value 规格小项
   */
  hideSpecValue(value: any) {
    value.isHidden = !value.isHidden;
    this.$forceUpdate();
  }

  /**
   * 将表格这一列的数据都置为首行该列的值
   * @param key 表格该列 key
   */
  fillColumn(key: 'length'|'width'|'height'|'weight'|'costDouble'|'freightDouble'|'hscode'|'ean') {
    if (this.formData.skuList) {
      const value = this.formData.skuList[0][key];
      for (let sku of this.formData.skuList){
        this.$set(sku, key, value);
      }
    }
  }

  formatHsCode(value: string | number | undefined): string {
    return String(value || '').replace(/\D/g, '').slice(0, 10);
  }

  updateHsCode(row: TSku, event: Event): void {
    const value = this.formatHsCode((event.target as HTMLInputElement).value);
    this.$set(row, 'hscode', value);
  }

  formatEan(value: string | number | undefined): string {
    return String(value || '').replace(/\D/g, '').slice(0, 14);
  }

  updateEan(row: TSku, event: Event): void {
    const value = this.formatEan((event.target as HTMLInputElement).value);
    this.$set(row, 'ean', value);
  }

  /**
   * 通过供应商链接填充sku信息
   */
  fillSkuByUrl(supperlierUrl: string, index: number) {
    // refresh=false: 解析sku走缓存（实时检测走"批量解析检测"按钮）
    getSkuFillList({supperlierUrl, refresh: false}, true).then(res => {
      if (res.data && res.data.code === 200) {
        this.fillSkuList = res.data.data || [];
        this.activeSkuIndex = index;
        this.fillSkuVisible = true;
      } else {
        this.$message.error(res.data.message);
      }
    }).catch(() => {})
  }

  /**
   * 选中sku
   */
  handleSkuChange(row: TSku) {
    this.activeFillSku = row;
  }

  /**
   * 确认填充sku
   */
  fillConfirm() {
    if (this.formData.skuList && this.activeSkuIndex >= 0 && this.activeFillSku) {
      const sku = this.formData.skuList[this.activeSkuIndex];
      sku.supplierProductId = this.activeFillSku.supplierProductId
      sku.aliSkuId = this.activeFillSku.aliSkuId
      sku.supplierSkuName = this.activeFillSku.supplierSkuName
      sku.cost = this.activeFillSku.cost
      sku.costDouble = this.activeFillSku.costDouble
    }
    this.activeSkuIndex = -1;
    this.activeFillSku = [];
    this.fillSkuVisible = false;
  }

  /**
   *  取消填充sku
   */
  fillClose() {
    this.activeSkuIndex = -1;
    this.activeFillSku = [];
    this.fillSkuVisible = false;
  }

  /**
   * sku选择变化钩子
   * @param selectedList
   */
  handleSelectionChange(selectedList: SpuManage[]) {
    this.skuSelectedList = selectedList;
    console.log(this.skuSelectedList);
  }

  /**
   *  编辑sku
   */
  editSku() {
    this.editingSku = {};
    this.editSkuVisible = true;
  }

    /**
     *  编辑sku供应商
     */
    editSkuSupp() {
        this.editSkuSupplierVisible = true;
        this.specDataToTable();
    }

  /**
   *  确认编辑sku
   */
  confirmSku() {
    console.log(this.skuSelectedList);
    for(let sku of this.skuSelectedList) {
      Object.assign(sku, this.editingSku)
    }
    this.editSkuVisible = false;
  }

    /**
     *  确认编辑sku供应商
     */
    confirmSkuSupplier() {
        this.specTableToData();
        this.getSkuTextBySpec(0, [], this.specData);
        this.editSkuSupplierVisible = false;
    }

  /**
   *  取消编辑sku
   */
  editClose() {
    this.editSkuVisible = false;
  }

    /**
     *  取消编辑sku供应商
     */
    editSupplierClose() {
        this.editSkuSupplierVisible = false;
    }

    /**
     * 批量编辑sku供应商时获取1688数据并放到表格
     */
    async getSpuAndPullTable(){
        this.newSupplierData = {
            'supperlierUrl': '',
            'orderRemark1688': '',
            "covers": [],
            "specList": [],
            "skuList": [],
            "spuAttrList": [],
            "similarList": [] // 弃用
        };
        this.specSelect = {};
        for (let specCol of this.specTableData){
            specCol.supplierSpecName = undefined;
            specCol.supplierSpecValueName = undefined;
        }

        if (this.newSupplierUrl === ''){
            return
        }
        await genSpuByUrl({ supperlierUrl: this.newSupplierUrl}, true).then(res => {
            if (res.data && res.data.code === 200) {
                this.newSupplierData = res.data.data;
                this.newSupplierData.covers = this.newSupplierData.covers || [];
                this.newSupplierData.specList = this.newSupplierData.specList || [];
                this.newSupplierData.skuList = this.newSupplierData.skuList || [];
                this.newSupplierData.similarList = this.newSupplierData.similarList || [];
                this.getSpecSelect();

            } else {
                this.$message.error(res.data.message);
            }
        }).catch(() => {});
    }

    /**
     * spec关联下拉选项数据获取
     */
    getSpecSelect() {
        this.specSelect = {};
        let selects : string[] = [];
        let valueMap : {[pros: string]: string[]} = {};
        let values : string[] = [];
        let specName : string = '';
        for (let spec of (this.newSupplierData.specList || [])){
            specName = spec.specName || '';
            selects.push(specName);
            values = [];
            for (let value of (spec.specValue || [])){
                values.push((value.baseName || value.name) || '');
            }
            valueMap[specName] = values;
        }
        this.specSelect.specNameSelects = selects;
        this.specSelect.valueSelectMap = valueMap;
    }

    /**
     * spec关联信息表格合并
     */
    specSpanMethod({ row, column, rowIndex, columnIndex }: any) {
        if (columnIndex === 1 || columnIndex === 2) {
            return this.specSpanCtrl[rowIndex] !== 0? [this.specSpanCtrl[rowIndex], 1]: [0, 0];
        }
    }

    /**
     * spec关联规格大项选择
     */
    baseSpecSelect(index: number, supplierSpecName: string) {
        if (this.specSpanCtrl[index] <= 0) {
            return;
        }
        for (let i = index; i < index + this.specSpanCtrl[index]; i++) {
            this.specTableData[i].supplierSpecName = supplierSpecName;
            this.specTableData[i].supplierSpecValueName = undefined;
        }
    }

    /**
     * spec关联规格小项选择
     */
    baseSelect(spec: SupplierSpecTable, id: string) {
        //不必更改base规格小项
        if (this.specSelect.valueSelectMap) {

        }
    }

    /**
     * spec表格初始化
     */
    specDataToTable() {
        let allSpecData : BaseAndSupplierSpec[] = JSON.parse(JSON.stringify(this.formData.specList)) || [];
        this.specSpanCtrl = [];
        this.specTableData = [];
        this.specSelect = {};
        this.specData = [];
        this.newSupplierUrl = '';
        this.newSupplierData = {
            'supperlierUrl': '',
            'orderRemark1688': '',
            "covers": [],
            "specList": [],
            "skuList": [],
            "spuAttrList": [],
            "similarList": [] // 弃用
        };

        allSpecData.sort(function (a,b) {
            return (a.specId || 0)-(b.specId || 0)
        });

        this.getSpecBySkuText(0, [], allSpecData);

        for (let spec of (this.specData || [])) {
            // 规格大项定位
            let position = this.specSpanCtrl.length;
            for (let value of (spec.specValue || [])) {
                this.specSpanCtrl.push(0);
                this.specSpanCtrl[position] += 1;
                this.specTableData.push({
                    specId: spec.specId,
                    specName: spec.specName,
                    resource: value.resource,
                    specValueName: value.name,
                    specValueBaseName: value.baseName,
                    supplierSpecName: undefined,
                    supplierSpecValueName: undefined
                })
            }
        }
    }

    /**
     * 供应商批量修改，递归生成规格小项笛卡尔积，与已选sku对比，将对应规格项放入要编辑数据集合
     */
    getSpecBySkuText(index : number, singleSpecList: BaseAndSupplierSpec[], allSpecData: BaseAndSupplierSpec[]) {
        if (index >= allSpecData.length){
            return
        }
        if (singleSpecList.length === 0){
            singleSpecList = [];
        }
        let specValues = allSpecData[index].specValue || [];
        let spec = JSON.parse(JSON.stringify(allSpecData[index]));
        for (let i=0; i< specValues.length; i++){
            spec.specValue = [];
            spec.specValue.push(specValues[i]);
            singleSpecList[index] = spec;

            if (index !== allSpecData.length-1){
                //没有遍历到最后一级规格项，指针+1，继续向下一级规格递归
                index ++;

                this.getSpecBySkuText(index, singleSpecList, allSpecData);
                //下一级的规格项都迭代完，这一级规格小项未迭代完，指针-1，再开始迭代这一级的下一个规格小项
                if (i !== specValues.length-1){
                    index --;
                }
            }else {
                //遍历到最后一级规格项，不再递归，取组装好的一个规格小项笛卡尔积和sku比较
                let skuTextStr = singleSpecList.map(function (obj, index) {
                      return (obj.specValue ? obj.specValue[0].baseName : '');
                }).join(',');
                for (let sku of this.skuSelectedList){
                      if (skuTextStr === sku.skuText){
                          this.setSpecData(singleSpecList);
                      }
                }
            }

        }
    }

    /**
     * 将选中sku对应的规格项数据放到 specData 中，供批量修改供应商时展示
     */
    setSpecData(singleSpecList: TSpec[]) {
        for (let singleSpec of (singleSpecList || [])){
            let res = false;
            for (let spec of (this.specData || [])){
                //先找到规格大项
                if (spec.specId === singleSpec.specId){
                    if (singleSpec.specValue && spec.specValue){
                        let values = spec.specValue.map(function (obj) {
                            return (obj.baseName ? obj.baseName : '');
                        });
                        //再找大项中有没有该小项，没有则插入该小项
                        if (values.indexOf(singleSpec.specValue[0].baseName || '') == -1){
                            let specValue: BaseAndSupplierSpecValue = {};
                            specValue.name = singleSpec.specValue[0].name;
                            specValue.baseName = singleSpec.specValue[0].baseName;
                            specValue.resource = singleSpec.specValue[0].resource;
                            spec.specValue?.push(specValue);
                        }
                        res = true;
                    }
                    continue;
                }
            }
            //res 为false，表示未找到规格大项，需要将规格大项添加进去
            if (!res){
                let tmpSpec: BaseAndSupplierSpec = {};
                tmpSpec.specId = singleSpec.specId;
                tmpSpec.specName = singleSpec.specName;
                tmpSpec.specValue = JSON.parse(JSON.stringify(singleSpec.specValue));
                this.specData.push(tmpSpec);
            }

        }
    }

    /**
     * spec表格提交格式转换
     */
    specTableToData() {
        const restoreArr = this.specSpanCtrl.filter((i:number) => (i > 0));
        const specs = this.specData || [];
        // 规格大项定位
        let position = 0;
        // 规格小项定位
        let position2 = 0;

        for (let [index, spec] of specs.entries()) {
            spec.specId = this.specTableData[position].specId;
            spec.specName = this.specTableData[position].specName;
            spec.supplierSpecName = this.specTableData[position].supplierSpecName;
            position += restoreArr[index];
            for (let valueAlign of (spec.specValue || [])) {
                valueAlign.name = this.specTableData[position2].specValueName;
                valueAlign.baseName = this.specTableData[position2].specValueBaseName;
                valueAlign.supplierSpecValueName = this.specTableData[position2].supplierSpecValueName;
                valueAlign.resource = this.specTableData[position2].resource;
                position2 += 1;
            }
        }
    }

    /**
     * 供应商批量修改提交，递归生成所选规格小项笛卡尔积和供应商规格笛卡尔积，与已选sku对比，
     * 将已选sku对应规格对应供应商sku信息id等信息更新到已选sku
     */
    getSkuTextBySpec(index : number, singleSpecList: BaseAndSupplierSpec[], allSpecData: BaseAndSupplierSpec[]) {
        if (index >= allSpecData.length){
            return
        }
        if (singleSpecList.length === 0){
            singleSpecList = [];
        }
        let specValues = allSpecData[index].specValue || [];
        let spec = JSON.parse(JSON.stringify(allSpecData[index]));
        for (let i=0; i< specValues.length; i++){
            spec.specValue = [];
            spec.specValue.push(specValues[i]);
            singleSpecList[index] = spec;

            if (index !== allSpecData.length-1){
                //没有遍历到最后一级规格项，指针+1，继续向下一级规格递归
                index ++;

                this.getSkuTextBySpec(index, singleSpecList, allSpecData);
                //下一级的规格项都迭代完，这一级规格小项未迭代完，指针-1，再开始迭代这一级的下一个规格小项
                if (i !== specValues.length-1){
                    index --;
                }
            }else {
                //遍历到最后一级规格项，不再递归，取组装好的一个规格小项笛卡尔积和sku比较
                let skuTextStr = singleSpecList.map(function (obj, index) {
                    return (obj.specValue ? obj.specValue[0].baseName : '');
                }).join(',');
                for (let sku of this.skuSelectedList){
                    if (skuTextStr === sku.skuText){
                        let supplierSkuTextStr = this.getSupplierSkuBySpec(JSON.parse(JSON.stringify(singleSpecList)));
                        if (supplierSkuTextStr === ''){
                            this.$message.error('供应商信息更新异常！');
                            return;
                        }
                        this.updateSupplierData(sku, supplierSkuTextStr);
                    }
                }
            }

        }
    }

    /**
     * 根据所选供应商规格项生成供应商sku描述
     */
    getSupplierSkuBySpec(singleSpecList: BaseAndSupplierSpec[]): string{
        let supplierValues : string[] = [];

          for (let spec of (this.newSupplierData.specList || [])){
              let singleSpec = singleSpecList.find(function (obj) {
                  return obj.supplierSpecName === spec.specName;
              });
              if (singleSpec === undefined || !singleSpec.specValue || !singleSpec.specValue[0].supplierSpecValueName){
                  this.$message.error('新供应商未与sku对齐！');
                  return '';
              }
              supplierValues.push(singleSpec.specValue[0].supplierSpecValueName);
          }
          return supplierValues.join(',');
    }

    /**
     * 更新sku的供应商信息
     */
    updateSupplierData(updateSku : TSku, supplierSkuTextStr: string){
        if (this.formData.skuList) {
            for (let sku of (this.formData.skuList || [])){
                if (sku.skuCode === updateSku.skuCode){
                    let supplierSku = (this.newSupplierData.skuList || []).find(function (obj) {
                        return obj.skuText === supplierSkuTextStr;
                    });
                    if (!supplierSku){
                        this.$message.error('供应商信息更新异常！');
                        return
                    }
                    sku.supplierProductId = supplierSku.supplierProductId;
                    sku.aliSkuId = supplierSku.aliSkuId;
                    sku.supplierSkuName = supplierSku.supplierSkuName;
                    sku.supplierUrl = this.newSupplierUrl;
                    sku.cost = supplierSku.cost;
                    sku.costDouble = supplierSku.costDouble;
                }
            }

        }
    }

    /**
     * 打开新链接图片
     * @param url
     */
    openImg(url: string): void {
        window.open(url, '_blank');
    }

    /**
   * 图片删除前确认钩子函数
   */
  beforeRemove(): any {
    return this.$confirm(`确定移除该图片吗？`);
  }

  /**
   * 轮播图删除钩子函数
   */
  handleRemove(file: {name: string, url: string}, list: any): void {
    this.coverList = [...list];
    this.coverShowList = [...list];
  }

  /**
   * 轮播图上传成功钩子函数
   */
  handleSuccess(res: any,file: any,fileList: any): void {
    if (res && res['result'][0]) {
      file.url = res['result'][0];
      // 图片根据上传顺序重新排序
      let front;
      for (let [index, item] of fileList.entries()) {
        if(item.status !== 'success' && !front) {
          front = index;
        }
        if (item.uid === file.uid && front) {
          fileList.splice(front,1,...fileList.splice(index, 1 , fileList[front]));
          break;
        }
        this.coverShowList = fileList;
      }
      this.coverList.push(file);
    }
    // ADD模式图片上传成功需要
    this.similarChecked = -1;
  }

  /**
   * 规格上传成功钩子函数
   */
  handleSuccess2(res: any, file: any, fileList: any, value: any): void {
    if (res && res['result'][0]) {
      value.resource = res['result'][0];
    }
    this.$forceUpdate();
  }

  /**
   * 图片上传失败钩子函数
   */
  handleError(): void {
    this.$message.warning('图片上传失败！');
  }

  /**
   * 图片展示
   */
  handlePictureCardPreview(file: {name: string, url: string}): void {
    this.dialogImageUrl = file.url;
    this.dialogVisible = true;
  }

  /**
   * 打开新的窗口
   */
  openWindow(url: string): void {
    window.open(url,'_blank');
  }
}
